import { render, staticRenderFns } from "./FacilityCategory.vue?vue&type=template&id=46bd8e1d"
import script from "./FacilityCategory.vue?vue&type=script&lang=js"
export * from "./FacilityCategory.vue?vue&type=script&lang=js"
import style0 from "./FacilityCategory.vue?vue&type=style&index=0&id=46bd8e1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports